import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { UnitMediStockModel } from 'src/app/models/UnitMediStockModel';
import { AppSettings } from 'src/app/shared/AppSettings';



@Injectable({
    providedIn: 'root'
})

export class UnitMediStockService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/UnitMediStockModel';

    getAllData() {
        return this.http.get<UnitMediStockModel[]>(this.baseurl + this.pathName).pipe(shareReplay(1));
    }
    
    getActiveDatas() {
        return this.http.get<UnitMediStockModel[]>(this.baseurl + this.pathName + '/GetActiveDatas' ).pipe(shareReplay(1));
    }

    getDataById(id: string) {
        return this.http.get<UnitMediStockModel>(this.baseurl + this.pathName + '/' + id);
    }

    // addData(data: UnitMediStockModel) {
    //     return this.http.post(this.baseurl + this.pathName, data).pipe(shareReplay(1));
    // }

    // deleteData(data: UnitMediStockModel) {
    //     return this.http.delete(this.baseurl + this.pathName + '/' + data.bedID);
    // }

    // updateData(data: UnitMediStockModel) {
    //     //   data.lastModifyLoginName = "2";
    //     return this.http.put(this.baseurl + this.pathName + '/' + data.shopID, data);
    // }
}